export const JWT_KEY = 'jwt';

export const MIN_MOVE_IN_OFFSET_DAYS = 3;
